import { object, string, null as zNull } from "zod";

export const createReviewDiscount = {
  input: object({ reviewId: string() }),
  output: object({
    discountCode: string(),
    formattedDiscountString: string(),
  }).or(zNull()),
};
